import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { bindMetaStorageListener, hydrateMetaStore } from './meta/metaStore'

hydrateMetaStore()
bindMetaStorageListener()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
